/**
 *  Player Lifetime Statistics Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var user = require('user');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        accessRules: {
            allow: ['user']
        },

        render: function(statisticType) {
            user.getPlayerLifetimeStatistics(statisticType)
                .done(this.updateView.bind(this.el));

            return this;
        },

        updateView: function(resp) {
            var value = resp.monetaryValue;
            this.innerHTML = window.Playtech.API.formatter.formatCurrency(value.amount, {currencyCode: value.currencyCode});
        }

    }, {
        nameOfReplacers: [
            'GET_LIFETIME_STATISTICS'
        ]
    });
});
